export const fontSizes = {
  heading1: "36px",
  heading2h: "32px",
  heading2: "24px",
  heading3: "20px",
  headingL: "18px",
  headingM: "16px",
  headingS: "14px",

  bodyXL: "20px",
  bodyL: "17px",
  bodyM: "15px",
  bodyS: "13px",
  bodyXS: "12px",
  bodyXXS: "10px",

  // global default font size
  body: "14px",

  // for mobile 16px to avoid autozooming
  bodyMobile: "16px",
};

export const lineHeights = {
  heading1: "44px",
  heading2h: "36px",
  heading2: "30px",
  heading3: "24px",
  headingL: "22px",
  headingM: "20px",
  headingS: "18px",

  bodyXL: "30px",
  bodyL: "24px",
  bodyM: "22px",
  bodyS: "20px",
  bodyXS: "18px",
  bodyXXS: "16px",

  body: "20px",
};

export const letterSpacings = {
  bodyXL: "1.5px",
  bodyL: "1.2px",
  bodyM: "1px",
  bodyS: "0.5px",
  bodyXS: "0.2px",
};

const jigsawV2FontWeights = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

const legacyFontWeights = {
  normal: 400,
  bold: 500, // Jigsaw v2 uses 500 for bold, overriding with this for now
  heavy: 600,
  extrabold: 700,

  heading1: "$bold",
  heading2h: "$bold",
  heading2: "$bold",
  heading3: "$bold",
  headingL: "$bold",
  headingM: "$bold",
  headingS: "$bold",
};

export const fontWeights = {
  ...jigsawV2FontWeights,
  ...legacyFontWeights,
};
